import { IFrequency } from './IFrequency';
import { IValueViewModel } from './viewModels';
import { ActualDataType } from './enum';
import { DigitalSet } from './entities';
import { IManualInput } from './IManualInput';

export class TagManualInputValues {
    classed? : {[className: string]:boolean};
    comment: string;
    dataType: ActualDataType;
    digitalSet?: DigitalSet;
    frequency?: IFrequency;
    guid: string;
    identifierVm?: IValueViewModel;
    max?: number;
    min?: number;
    name: string;
    style?: { [key: string]: any };
    unit: string;
    values: IManualInput[];
    viewModel: IValueViewModel;

    constructor() {
        this.values = [];
    }
}